<template>
  <v-container class="py-5">
    <v-row justify="center">
      <v-col cols="12" sm="10" md="8">
        <v-card outlined>
          <!-- Titre principal -->
          <v-card-title>
            <h1 class="text-h5" v-if="this.$store.state.loggedUser.job == 'NUTRITIONIST'">
              Création d'une recommandation
            </h1>
            <h1 class="text-h5" v-else>Création d'une expérience alimentaire</h1>
          </v-card-title>

          <!-- Formulaire -->
          <v-form @submit.prevent="submitForm" ref="form">
            <v-card-text>
              <!-- Titre -->
              <v-text-field v-model="form.title" label="Titre" outlined dense required></v-text-field>

              <!-- Description générale -->
              <v-textarea
                v-model="form.description_general"
                label="Description générale"
                outlined
                dense
                required
              ></v-textarea>

              <!-- Description générale -->
              <v-textarea
                v-model="form.description_consumer"
                label="Description destinée aux consommateurs"
                outlined
                dense
                required
              ></v-textarea>

              <!-- Description de la scène -->
              <v-textarea
                v-model="form.description_scene"
                label="Description de la scène"
                outlined
                dense
                required
              ></v-textarea>

              <!-- Description de l'influence -->
              <v-textarea
                v-model="form.description_influence"
                label="Description de l'influence"
                outlined
                dense
                required
              ></v-textarea>

              <!-- Conditions -->
              <v-textarea v-model="form.conditions" label="Conditions" outlined dense required></v-textarea>

              <!-- Durée -->
              <v-text-field
                v-model="form.duration"
                label="Durée (en jours)"
                outlined
                dense
                required
                type="number"
              ></v-text-field>

              <!-- Problèmes (Concerns) -->
              <v-select
                v-model="form.concerns"
                :items="concerns"
                item-value="id"
                item-text="title"
                label="Problèmes associés"
                outlined
                dense
                multiple
                required
              ></v-select>

              <!-- Enquêtes (Surveys) -->
              <v-select
                v-model="form.surveys"
                :items="surveys"
                item-value="id"
                item-text="name"
                :label="getLabel()"
                outlined
                dense
                multiple
                required
              ></v-select>
            </v-card-text>

            <!-- Boutons -->
            <v-card-actions class="justify-end">
              <v-btn text color="primary" @click="stopCreation">Annuler</v-btn>
              <v-btn color="primary" type="submit" elevation="2">Créer</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      form: {
        title: "",
        description_general: "",
        description_scene: "",
        description_influence: "",
        conditions: "",
        duration: "",
        concerns: [],
        surveys: [],
      },
      concerns: [],
      surveys: [],
      durationMenu: false,
    }
  },
  methods: {
    fetchData() {
      console.log("Fetching initial data...")
      // Fetch concerns (Issues)
      this.$store
        .dispatch("fetchAllConcerns")
        .then((response) => {
          this.concerns = response
          console.log("Fetched concerns", this.concerns, response)
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
      // Fetch surveys
      this.$store
        .dispatch("fetchAllSurveys")
        .then((response) => {
          // Filtrer les surveys dont le slug ne commence pas par 'COPY_'
          this.surveys = response.filter((s) => !s.slug || !s.slug.startsWith("COPY_"))
          console.log("Fetched surveys", this.surveys, response)
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
    },
    submitForm() {
      console.log("Form data", this.form)

      // Call the store action to create an EatingExperience
      this.$store
        .dispatch("CreateEatingExperience", { payload: this.form })
        .then(() => {
          console.log("Experience created successfully")
          this.$router.push({ name: "EatingExperiencePage" }) // Redirect to home page or another relevant page
        })
        .catch((error) => {
          console.error("Error during experience creation:", error)
          this.$store.dispatch("notifyServerError") // Notify on server error
        })
    },
    clearForm() {
      this.form = {
        title: "",
        description_general: "",
        description_scene: "",
        description_influence: "",
        conditions: "",
        duration: "",
        concerns: [],
        surveys: [],
      }
    },
    stopCreation() {
      this.clearForm()
      this.$router.push({ name: "EatingExperiencePage" })
    },
    getLabel() {
      const job = this.$store.state.loggedUser.job
      if (job == "RESEARCHER") {
        return "Sondages associés"
      } else {
        return "Enquêtes associées"
      }
    },
  },

  mounted() {
    this.fetchData() // Fetch initial data for dropdowns
  },
}
</script>

<style scoped>
.v-container {
  max-width: 800px;
  margin: auto;
}

.v-card-title {
  justify-content: center;
  font-weight: bold;
}

.v-card-actions {
  padding: 16px;
}
</style>
